export function SwitchIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M14.4712 5.8047C14.7316 5.54435 14.7316 5.12224 14.4712 4.86189L12.4712 2.86189C12.2109 2.60154 11.7888 2.60154 11.5284 2.86189C11.2681 3.12224 11.2681 3.54435 11.5284 3.8047L12.3904 4.66663L1.99984 4.66663C1.63165 4.66663 1.33317 4.9651 1.33317 5.33329C1.33317 5.70148 1.63165 5.99996 1.99984 5.99996L12.3904 5.99996L11.5284 6.86189C11.2681 7.12224 11.2681 7.54435 11.5284 7.8047C11.7888 8.06505 12.2109 8.06505 12.4712 7.8047L14.4712 5.8047Z"
        fill="currentColor"
      />
      <path
        d="M3.52843 8.19522L1.52843 10.1952C1.26808 10.4556 1.26808 10.8777 1.52843 11.138L3.52843 13.138C3.78878 13.3984 4.21089 13.3984 4.47124 13.138C4.73159 12.8777 4.73159 12.4556 4.47124 12.1952L3.60931 11.3333L13.9998 11.3333C14.368 11.3333 14.6665 11.0348 14.6665 10.6666C14.6665 10.2984 14.368 9.99996 13.9998 9.99996L3.60931 9.99996L4.47124 9.13803C4.73159 8.87768 4.73159 8.45557 4.47124 8.19522C4.21089 7.93487 3.78878 7.93487 3.52843 8.19522Z"
        fill="currentColor"
      />
    </svg>
  );
}
